import Vue from 'vue';
import axios from 'axios';
import * as collectionApi from '@/api/artist/collections.js';

const state = {
  // from query string in url (camelCase)
  query: {
  },
  filters: {
  },
  querys: {
    q: '',
    sort: '',
    page: 1,
    per_page: 5,
    type: '',
  },
  filtersList: [
    'status',
    'per_page',
  ],

  collections: [],
  selectedCollections: [],

  pagination: {
    totalCount: 0,
    currentPage: 1,
    perPage: 10,
  },

  tablePreferences: {
    columns: [],
  },

  cancelTokens: {},
};

const getters = {
  // querys: state => state.querys,
  keyword: state => _.get(state.query, 'q'),

  filtersList: state => state.filtersList,
  hasSelectedFilters: state => _.size(_.omitBy(state.filters, _.isNil)) > 0,

  collections: state => state.collections,
  hasSelectedCollections: state => state.selectedCollections.length > 0,

  tablePreferences: state => state.tablePreferences,

  totalCount: state => state.pagination.totalCount,
  currentPage: state => state.pagination.currentPage,
  perPage: state => state.pagination.perPage,
  // totalPageCount: state => Math.ceil(state.pagination.totalRows / state.pagination.perPage),
};

function refreshCancelToken(state, tokenName) {
  // cancel previous request
  if (_.has(state.cancelTokens, tokenName)) {
    const info = {
      type: 'cancelToken',
      name: `${tokenName}`,
    };
    state.cancelTokens[tokenName].cancel(info);
  }

  // create cancel token
  state.cancelTokens[tokenName] = axios.CancelToken.source();

  return state.cancelTokens[tokenName];
}

function updateListState(state, updateRow) {
  if (!updateRow.status) return;

  if (state.collections && state.collections.length) {
    const index = state.collections.findIndex(x => x.id === updateRow.id);
    Vue.set(state.collections, index, { ...state.collections[index], ...updateRow });
  }
}

const actions = {
  listCollectionsWithPage({ commit }, params) {
    console.log('listCollectionsWithPage actions', params);

    const cancelToken = refreshCancelToken(state, 'listCollectionsWithPage');
    const axiosConfig = {
      cancelToken: cancelToken.token,
    };

    return collectionApi.listCollectionsWithPage(params, axiosConfig)
      .then((response) => {
        console.log('listCollectionsWithPage actions', params);

        commit('setCollections', response.data.data);
        commit('setPagination', response.data);
        return response;
      });
  },
  setCurrentPage({ commit }, number) {
    commit('setCurrentPage', number);
  },

  // setSelectedCollections({ commit }, ids) {
  //   commit('setSelectedCollections', ids);
  // },

  deleteCollection({ state }, collectionId) {
    console.log('deleteCollection action', collectionId);
    if (!collectionId) return;

    return collectionApi.deleteCollection(collectionId)
      .then((response) => {
        console.log('deleteCollection deleted', response);

        const updateRow = response.data.data;
        if (_.size(updateRow)) {
          updateListState(state, updateRow);
        }
      });
  },

  setQuery({ commit }, query) {
    const filters = {};

    if (query.status) {
      filters.status = query.status;
    }

    commit('setFilters', filters);
    commit('setQuery', query);
  },

  setFilters({ commit }, filters) {
    commit('setFilters', filters);
  },

  getTablePreferences({ commit }) {
    if (typeof (Storage) !== 'undefined') {
      // test using sessionStorage first
      const json = sessionStorage.getItem('artist.elements.table.preferences.columns');
      // check for json before parsing to avoid error
      if (json) {
        const columns = JSON.parse(json);
        // console.log('getTablePreferences', preference);
        commit('setTablePreferences', {
          columns: columns,
        });
      }
    }
  },

  setTablePreferences({ commit }, preferences) {
    commit('setTablePreferences', preferences);
  },

};

const mutations = {
  setCollections(state, list) {
    state.collections = list;
  },

  // setSelectedCollections(state, ids) {
  //   console.log('setSelectedCollections', ids, ids.length);
  //   state.selectedCollections = ids || [];
  // },

  setQuery(state, query) {
    console.log('setQuery', query);
    state.query = query;
  },

  setFilters(state, filters) {
    state.filters = filters;
  },

  setElements(state, data) {
    state.elements = data;
  },

  setCurrentMediaType(state, mediaType) {
    state.currentMediaType = mediaType;
  },

  // pagination
  setCurrentPage(state, number) {
    state.pagination.currentPage = parseInt(number, 10);
  },

  setPerPage(state, number) {
    state.pagination.perPage = parseInt(number, 10);
  },

  setPagination(state, data) {
    state.pagination.currentPage = data.page;
    state.pagination.perPage = data.perPage;
    state.pagination.itemPerPage = data.perPage;
    state.pagination.totalCount = data.totalCount;
    // state.pagination.totalPage = Math.ceil(response.totalCount / response.perPage, 10);
  },

  setTablePreferences(state, preferences) {
    if (typeof (Storage) !== 'undefined') {
      localStorage.removeItem('tablePreference');

      if (_.has(preferences, 'columns')) {
        // test using sessionStorage first
        sessionStorage.setItem('artist.collection.table.preferences.columns', JSON.stringify(preferences.columns));
      }
    }

    const tablePreferences = { ...state.tablePreferences, ...preferences };

    console.log('setTablePreferences', tablePreferences);
    state.tablePreferences = tablePreferences;
  },

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
